{
  "name": "tractorpal",
  "description": "TractorPal: A Personal Inventory and Maintenance Tracker",
  "version": "3.4.13",
  "author": "TractorPal",
  "homepage": "http://www.tractorpal.com/",
  "packageManager": "npm@11.2.0+sha512.3dc9c50ba813a3d54393155a435fe66404b72685ab0e3008f9ae9ed8d81f6104860f07ed2656dd5748c1322d95f3140fa9b19c59a6bba7750fd12285f81866da",
  "engines": {
    "node": ">=20.18.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "prepare-production": "./scripts/prepare-production.sh",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:emulators": "firebase emulators:exec \"npm test -- --no-watch --browsers=ChromeHeadless\"",
    "lint": "NODE_OPTIONS=--max_old_space_size=8048 ng lint",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org tractorpal --project tractorpal-app ./www && sentry-cli sourcemaps upload --org tractorpal --project tractorpal-app ./www",
    "e2e": "ng e2e",
    "e2e:emulators": "firebase emulators:start"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/fire": "^19.0.0",
    "@angular/forms": "^19.2.3",
    "@angular/platform-browser": "^19.2.3",
    "@angular/platform-browser-dynamic": "^19.2.3",
    "@angular/router": "^19.2.3",
    "@capacitor-community/admob": "^7.0.2",
    "@capacitor-community/apple-sign-in": "^7.0.0",
    "@capacitor-community/facebook-login": "^7.0.0",
    "@capacitor-community/safe-area": "^7.0.0-alpha.1",
    "@capacitor/android": "^7.1.0",
    "@capacitor/angular": "^2.0.3",
    "@capacitor/app": "^7.0.1",
    "@capacitor/camera": "^7.0.0",
    "@capacitor/core": "^7.1.0",
    "@capacitor/filesystem": "^7.0.0",
    "@capacitor/haptics": "^7.0.0",
    "@capacitor/ios": "^7.1.0",
    "@capacitor/keyboard": "^7.0.0",
    "@capacitor/share": "^7.0.0",
    "@capacitor/splash-screen": "^7.0.0",
    "@ionic/angular": "^8.5.1",
    "@ionic/core": "^8.5.1",
    "@maskito/angular": "^3.5.0",
    "@maskito/core": "^3.5.0",
    "@maskito/kit": "^3.5.0",
    "@revenuecat/purchases-capacitor": "^10.2.1",
    "@sentry/angular": "^10.50.0",
    "date-fns": "^4.1.0",
    "firebase-admin": "^12.7.0",
    "ionicons": "^7.4.0",
    "lodash-es": "^4.17.21",
    "mixpanel-browser": "^2.61.2",
    "ngx-extended-pdf-viewer": "^22.3.9",
    "pdfmake": "^0.2.18",
    "rxjs": "~7.8.1",
    "tslib": "^2.3.0",
    "zod": "^4.1.12",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^19.0.1",
    "@angular-devkit/build-angular": "^19.2.4",
    "@angular-eslint/builder": "^19.3.0",
    "@angular-eslint/eslint-plugin": "^19.0.0",
    "@angular-eslint/eslint-plugin-template": "^19.0.0",
    "@angular-eslint/schematics": "^19.3.0",
    "@angular-eslint/template-parser": "^19.3.0",
    "@angular/cli": "^19.2.4",
    "@angular/compiler": "^19.2.0",
    "@angular/compiler-cli": "^19.2.3",
    "@angular/language-service": "^19.2.3",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^7.1.0",
    "@firebase/rules-unit-testing": "^4.0.1",
    "@ionic/angular-toolkit": "^11.0.1",
    "@ionic/cli": "^7.2.1",
    "@playwright/test": "^1.51.1",
    "@types/jasmine": "~5.1.0",
    "@types/lodash-es": "^4.17.12",
    "@types/mixpanel-browser": "^2.51.0",
    "@types/node": "^22.13.11",
    "@types/pdfmake": "^0.2.11",
    "@typescript-eslint/eslint-plugin": "8.0.0",
    "@typescript-eslint/parser": "8.0.0",
    "eslint": "^8.57.1",
    "eslint-plugin-deprecation": "^2.0.0",
    "eslint-plugin-import": "2.29.1",
    "firebase-tools": "^13.35.1",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "native-run": "^1.7.4",
    "playwright-ng-schematics": "^2.0.3",
    "prettier": "^3.5.3",
    "process": "^0.11.10",
    "source-map-explorer": "^2.5.3",
    "typescript": "~5.5.4"
  },
  "optionalDependencies": {
    "ios-deploy": "^1.12.2"
  },
  "browserslist": [
    "Chrome >=79",
    "ChromeAndroid >=79",
    "Firefox >=70",
    "Edge >=79",
    "Safari >=14",
    "iOS >=14"
  ]
}